// [SPRINT K P1] Quotes store — localStorage mock pour devis.
// MOCK: clé `aya_quotes_${userId}` = array<quote>.

const KEY = (uid) => `aya_quotes_${String(uid || 'anon')}`;

export function loadQuotes(uid) {
  try { return JSON.parse(localStorage.getItem(KEY(uid)) || '[]') || []; }
  catch (_) { return []; }
}

export function appendQuote(uid, quote) {
  const list = loadQuotes(uid);
  const next = [...list, quote];
  try { localStorage.setItem(KEY(uid), JSON.stringify(next)); } catch (_) { /* non-fatal */ }
  return next;
}

const _api = { loadQuotes, appendQuote };
export default _api;
